import { Controller } from "@hotwired/stimulus";

// Handles toggling of the header navigation on smaller screens.
export default class extends Controller {
  static targets = ["menu", "toggle"];

  connect() {
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.handleResize);
    this.close();
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize);
  }

  toggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  handleMenuClick(event) {
    if (window.innerWidth >= 992) return;
    if (!event.target.closest("a")) return;
    this.close();
  }

  open() {
    this.menuTarget.classList.add("is-open");
    this.toggleTarget.setAttribute("aria-expanded", "true");
  }

  close() {
    this.menuTarget.classList.remove("is-open");
    this.toggleTarget.setAttribute("aria-expanded", "false");
  }

  isOpen() {
    return this.menuTarget.classList.contains("is-open");
  }

  handleResize() {
    if (window.innerWidth >= 992) {
      this.close();
    }
  }
}
